<ion-app>
    <div class="flex flex-1 flex-col">
        <ion-header class="shadow-[0_1px_0_var(--border)]!">
            @if (instanceName) {
                <ion-toolbar class="instance-wrapper bg-warning text-warning-contrast">
                    <div class="flex justify-center">
                        <div class="flex items-center space-x-2 py-1.5">
                            <fa-icon class="text-sm!" icon="code"></fa-icon>
                            <span>{{ instanceName }}</span>
                        </div>
                    </div>
                </ion-toolbar>
            }
        </ion-header>
        <div class="relative flex-1">
            <ion-router-outlet></ion-router-outlet>
        </div>
    </div>
</ion-app>
